export const removeHtmlTags = (inputString) => {
  if (!inputString) return '';

  return inputString
    .replace(/<a[^>]*>.*?<\/a>/gi, '')
    .replace(/<img[^>]*>/gi, '')
    .replace(/<[^>]*>/g, '')
    .trim();
};

export default removeHtmlTags;
